export const gtmReportSignup = (subdomain: string) => {
	const w: any = window;
	if (w && w.dataLayer && w.dataLayer.push) {
		try {
			w.dataLayer.push({
				event: 'Successful Signup',
				subdomain
			});
		} catch (e) {
			console.warn('cannot push to gtm', e);
		}
	} else {
		console.warn('cannot push to gtm - no data layer');
	}
};

export const gtmPushEvent = (event: string, eventCategory: string, eventAction: string, eventLabel: string) => {
	const w: any = window;
	if (w && w.dataLayer && w.dataLayer.push) {
		try {
			w.dataLayer.push({
				event,
				eventCategory,
				eventAction,
				eventLabel
			});
		} catch (e) {
			console.warn('cannot push to gtm', e);
		}
	} else {
		console.warn('cannot push to gtm - no data layer');
	}
};

export const updateFreeTrialGtmEvent = (source: string) => {
	const event = 'free-trial-event';
	const category = 'Free Trial Requested';
	const action = source || '';
	const label = document.location.href;
	gtmPushEvent(event, category, action, label);
};

export const getGaClientId = () => {
	const w: any = window;
	if (w && w.ga) {
		try {
			return w.ga.getAll()[0].get('clientId');
		} catch (e) {
			console.warn(e);
		}
	} else {
		return;
	}
};
